import { Code2, PenTool, Workflow } from "lucide-react";
import Reveal from "../components/Reveal";

const SERVICES = [
  {
    number: "01",
    icon: PenTool,
    name: "Website Design",
    tagline: "Designed around your business — not a theme",
    summary:
      "Modern, responsive websites designed around your business, your customers, and your brand. Every layout is composed to build trust and guide visitors toward contacting you.",
    features: ["Custom design, never templates", "Responsive on every device", "Conversion-focused page structure"],
    testid: "service-design-card",
  },
  {
    number: "02",
    icon: Code2,
    name: "Development",
    tagline: "Fast, clean engineering that just works",
    summary:
      "Fast, responsive websites with integrations and functionality tailored to your business — built on modern technology, not bloated page builders.",
    features: ["Modern component architecture", "Booking, forms & CMS integrations", "SEO-friendly, semantic code"],
    testid: "service-development-card",
  },
  {
    number: "03",
    icon: Workflow,
    name: "Automation",
    tagline: "Systems that handle the repetitive work",
    summary:
      "Connect forms, scheduling, CRM systems, payments, and analytics into workflows that run themselves — so nothing slips through the cracks.",
    features: ["Lead capture & instant notifications", "Scheduling & CRM connections", "Payments & analytics pipelines"],
    testid: "service-automation-card",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative bg-navy py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">WHAT WE DO</p>
          <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Three disciplines. One digital system.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-400">
            Every engagement combines design, engineering, and automation — so your website doesn't just look
            professional, it works for your business around the clock.
          </p>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 gap-7 md:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.12}>
              <article
                data-testid={s.testid}
                className="group flex h-full flex-col rounded-2xl border border-navyline bg-navycard p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 sm:p-9"
              >
                <div className="flex items-center justify-between">
                  <s.icon className="h-7 w-7 text-gold transition-transform duration-500 group-hover:scale-110" strokeWidth={1.6} />
                  <span className="font-mono text-sm font-semibold tracking-widest text-slate-600">{s.number}</span>
                </div>
                <h3 className="mt-7 font-display text-xl font-bold text-white">{s.name}</h3>
                <p className="mt-1.5 text-sm font-medium text-gold/90">{s.tagline}</p>
                <p className="mt-4 text-sm leading-relaxed text-slate-400">{s.summary}</p>
                <ul className="mt-6 space-y-2.5 border-t border-navyline/70 pt-6">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2.5 text-[13px] text-slate-300">
                      <span className="h-1 w-1 rotate-45 bg-gold" aria-hidden="true" />
                      {f}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
